import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import PrerenderGlobals from './PrerenderGlobals';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AchievementNotFound = ({
  brochureRoot,
  language
}) => {
  return /*#__PURE__*/_jsxs(ErrorMessage, {
    "data-test-id": "achievement-public-not-found",
    type: "notFound",
    children: [/*#__PURE__*/_jsx(PrerenderGlobals, {
      language: language,
      wasFound: false
    }), /*#__PURE__*/_jsxs("p", {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.certification.notFound"
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Link, {
        href: brochureRoot,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.certification.backToAcademy"
        })
      })]
    })]
  });
};
export default AchievementNotFound;